module.exports = __webpack_public_path__ + "static/media/400411_02.cc072865.png";